import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const FireIcon = ({ size = 14, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="currentColor">
    <path d="M12 2c0 0 5 4 5 9 0 1-0.5 2-1.5 2.5 0.5-1.5 0-3-1-4-0.5 2-2 3-3 5-1 2 0 4 1.5 4.5C9 19 7 17 7 14c0-3 2-4 2-7 0-2-1-3-1-3s4 0 4-2z" />
  </svg>
)
